// extracted by mini-css-extract-plugin
export default {"operationArea":"TradeManagement_operationArea__sUWGn"};